import React from 'react';
import { FormattedMessage } from 'react-intl';

/**
 * This Component creates Subheader (in case of many usages - Subheaders) for every page
 */
const SubHeader = props => {
    const {
        additionalElement,
        additionalElementClassName,
        additionalElementStyle,
        auxClassName,
        auxText,
        headerClassName,
        text,
        textReplacements = {},
        auxTextReplacements = {},
        dataTestId
    } = props;

    return (
        <div className="page-header">
            <div className="grid-row">
                <div className="mobile:grid-col-12 tablet:grid-col-fill">
                    <h4 data-testid={dataTestId ?? text} className={`${headerClassName}`}>
                        <FormattedMessage
                            id={text}
                            values={textReplacements}
                        />
                        &nbsp;
                        {
                            auxText && (
                                <span className={`${auxClassName}`}>
                                    <FormattedMessage
                                        id={auxText}
                                        values={auxTextReplacements}
                                    />
                                </span>
                            )
                        }
                    </h4>
                </div>
                {
                    additionalElement && (
                        <div className="mobile:grid-col-12 tablet:grid-col-auto">
                            <span
                                className={additionalElementClassName}
                                style={additionalElementStyle}
                            >
                                { additionalElement }
                            </span>
                        </div>
                    )
                }
            </div>
        </div>
    );
};

export default SubHeader;